import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { API_URL } from "../../../config";
import axios from "axios";
import moment from "moment";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import CkEditorBlog from "../Forms/CkEditor/CkEditorBlog";
import { toast } from "react-toastify";
import { logout } from "../../../store/actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { setCourses } from "../../../store/actions/CourseAction";

const jobTypeOptions = [
  { value: "full-time", label: "Full Time" },
  { value: "part-time", label: "Part Time" },
  { value: "contract", label: "Contract" },
  { value: "internship", label: "Internship" },
  { value: "remote", label: "Work From Home" },
];

const CampusDriveDetails = () => {
  const { driveId } = useParams();
  const [drive, setDrive] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copyMessagePhone, setCopyMessagePhone] = useState(false);
  const [copyMessageEmail, setCopyMessageEmail] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [formType, setFormType] = useState("Email");
  const [message, setMessage] = useState("");
  const [passoutyear, setPassoutYear] = useState(null);
  const [masterCourseId, setMasterCourseId] = useState(null);
  const [specializationId, setspecializationId] = useState(0);
  const [courseId, setCourseId] = useState(null);
  const [specialization, setSpecialization] = useState([]);
  const [isSendingNotification, setIsSendingNotification] = useState(false);
  const dispatch = useDispatch();
  const collegeId = useSelector((state) => state.college_id.college_id);
  const currentYear = new Date().getFullYear();
  const courses = useSelector((state) => state.courses.courses);

  useEffect(() => {
    if (masterCourseId !== null) {
      const coursemaster = courses?.find(
        (courses) => courses?.course_master_id == masterCourseId,
      );
      setCourseId(coursemaster?.college_course_id);
    }
  }, [masterCourseId, courses]);

  useEffect(() => {
    if (courseId != null) {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      const payload = { college_id: collegeId, course_id: courseId };
      axios
        .get(
          `${API_URL}/api/freshment_portal_apis/GenericAPI/get_course_spealization_list`,
          {
            params: payload,
            headers: {
              Authorization: authToken,
            },
          },
        )
        .then((response) => {
          setSpecialization(response.data.data);
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            dispatch(logout());
          }
          console.log("err======", err);
        });
    }
  }, [courseId, collegeId, dispatch]);
  const fetchDrive = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;
    try {
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/CampusDrive/get_campus_drive_job_details_post`,
        {
          params: {
            campus_drive_id: driveId,
            college_id: collegeId,
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data?.success) {
        setDrive(response.data?.data);
        setError(null);
      } else {
        setError(response.data?.message || "Failed to fetch details");
      }
    } catch (error) {
      setError("Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setMessage(data);
  };

  const sendNotification = (props) => {
    if (passoutyear == null) {
      toast.error("Please select passout year");
      return;
    }

    setIsSendingNotification(true);

    const params = new URLSearchParams();
    params.append("notification_type", "Email");
    params.append("campus_drive_id", props.job);
    params.append("job_id", 0);
    params.append("college_connect_id", collegeId);
    params.append("notification_message", props.message);
    params.append("passout_year", props.passoutyear);
    params.append("course_id", parseInt(props.masterCourseId));
    params.append("specialization_id", props.specializationId);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/jobs/send_job_notification`,
        params,
        {
          headers: {
            Authorization: authToken,
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        },
      )
      .then((res) => {
        setIsSendingNotification(false);
        if (res.data.success) {
          toast.success(res.data.message);
          setModalShow(false);
          setMessage("");
          setPassoutYear(null);
          setCourseId(null);
          setspecializationId(0);
        } else {
          toast.error(res.data.message);
        }
        // console.log(res);
      })
      .catch((err) => {
        setIsSendingNotification(false);
        if (err?.response?.status === 401) {
          dispatch(logout());
        }
        console.log("err======", err);
        toast.error("Failed to send notification");
      });
  };

  const sendAnalysis = (props) => {
    const params = new URLSearchParams();
    params.append("job_id", 0);
    params.append("campus_drive_id", props.job);
    params.append("college_id", collegeId);
    params.append("analysis_type", props.analysis);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/jobs/add_job_analysis`,
        params,
        {
          headers: {
            Authorization: authToken,

            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        },
      )
      .then((res) => {
        // console.log(res);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          dispatch(logout());
        }
        console.log("err======", err);
      });
  };

  useEffect(() => {
    fetchDrive();
  }, [driveId]);

  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  if (loading)
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-2">Loading campus drive...</p>
      </div>
    );
  if (error) return <div className="text-center py-5 text-danger">{error}</div>;
  if (!drive) return <div className="text-center py-5">No details found.</div>;

  // Helper for LPA salary
  const getSalaryLPA = (salary) => {
    if (!salary) return "Industry Standard";
    const num = Number(salary);
    if (isNaN(num)) return salary;
    const lpa = num / 100000;
    return `${lpa % 1 === 0 ? lpa.toFixed(0) : lpa.toFixed(1)}`;
  };

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === "phone") {
      setCopyMessagePhone(true);
      setTimeout(() => setCopyMessagePhone(false), 2000);
    } else if (type === "email") {
      setCopyMessageEmail(true);
      setTimeout(() => setCopyMessageEmail(false), 2000);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-4 flex-wrap justify-content-between">
        <h4 className="fs-20 font-w600 me-auto">Campus Drive Details</h4>
        <div className="d-flex align-items-center gap-2">
          <div>
            <Button
              variant="info"
              size="md"
              as={Link}
              to={`/application-details/drive/${driveId}`}
            >
              <i className="fas fa-list me-2"></i>View Interested
            </Button>
          </div>
          <div>
            <Button
              as="button"
              onClick={() => {
                setFormType("Email");
                setModalShow(true);
              }}
              size="md"
              className="btn-primary"
            >
              <i className="fas fa-envelope me-2" area-hidden="true"></i>
              Send Email To Student
            </Button>
          </div>
          {/* <div>
            <Button
              onClick={() => {
                setFormType("Push");
                setModalShow(true);
                sendAnalysis({
                  analysis: "send_notification",
                  job: driveId,
                });
              }}
              type="button"
              variant="primary"
              size="md"
            >
              <i className="fas fa-share me-2"></i>
              Send Notification
            </Button>
          </div> */}
        </div>
      </div>
      <div className="row align-items-start">
        {/* Sidebar with Overview */}
        <div className="col-lg-4 col-md-12 mb-4">
          <div>
            <div className="card" style={{ height: "fit-content" }}>
              <div className="card-header border-0 pb-0">
                <h5 className="mb-3 fs-20">Campus Drive Statistics</h5>
              </div>
              <div className="px-2">
                <div className="row g-3">
                  <div className="col-4">
                    <div className="stat-box text-center py-3">
                      <h2 className="fs-20 mb-1 font-w600">
                        {drive?.college_students_visited || 0}
                      </h2>
                      <span className="fs-14 text-muted">Visited</span>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="stat-box text-center py-3">
                      <h2 className="fs-20 mb-1 font-w600 text-secondary">
                        {drive?.college_students_interested || 0}
                      </h2>
                      <span className="fs-14 text-secondary">Interested</span>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="stat-box text-center py-3">
                      <h2 className="fs-20 mb-1 font-w600 text-danger">
                        {drive?.college_students_not_interested || 0}
                      </h2>
                      <span className="fs-14 text-danger">Not Interested</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer border-0 pt-2 pb-4">
                <Link
                  to={`/students-activity`}
                  className="btn btn-sm btn-primary px-4"
                >
                  <i className="fas fa-chart-bar me-2"></i>View Statistics
                </Link>
              </div>
            </div>
          </div>
          <div className="card" style={{ height: "fit-content" }}>
            <div className="card-header border-0 pb-0">
              <h4 className="fs-20 mb-0">Overview</h4>
            </div>
            <div className="card-body pt-4">
              <div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">Job Type:</h5>
                  <span>
                    {jobTypeOptions.find(
                      (option) => option.value === drive.job_type,
                    )?.label || "N/A"}
                  </span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">
                    {drive.job_type === "internship" ? "Stipend" : "Salary"}:
                  </h5>
                  <span>
                    {drive?.job_type === "internship"
                      ? `${drive.salary} per month`
                      : `${getSalaryLPA(drive.salary)} LPA`}
                  </span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">
                    Compensation Details:
                  </h5>
                  <span>&nbsp;{drive.compensation_details || "N/A"}</span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">Vacancy:</h5>
                  <span>{drive.total_vacancy || "N/A"}</span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">
                    Job Location:
                  </h5>
                  <span>{drive.job_location || "Pan India"}</span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">
                    Joining Date:
                  </h5>
                  <span>
                    {moment(drive.joining_date).isValid()
                      ? moment(drive.joining_date).format("DD-MM-YYYY")
                      : "TBD"}
                  </span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">
                    Passout Year:
                  </h5>
                  <span>{drive.passout_year || "N/A"}</span>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                  <h5 className="mb-1 fs-14 custom-label me-1">HR Name:</h5>
                  <span>{drive.hr_contact_person || "N/A"}</span>
                </div>
                {/* Contact Number */}
                {drive.hr_contact_number && (
                  <div className="mb-4 d-flex flex-wrap align-items-center">
                    <h5 className="mb-1 fs-14 custom-label me-1">
                      Contact No. :
                    </h5>
                    <span className="me-2">{drive.hr_contact_number}</span>
                    <div
                      className="copy-division2 fs-18 me-2 text-dark cursor-pointer"
                      onClick={() =>
                        handleCopy(drive.hr_contact_number, "phone")
                      }
                    >
                      <i className="fas fa-copy me-1 fs-18 icon-copy"></i>
                      {copyMessagePhone && (
                        <span
                          style={{ zIndex: 10 }}
                          className="copy-message fade-in-out"
                        >
                          Number copied!
                        </span>
                      )}
                    </div>
                    <a
                      href={`tel:${drive.hr_contact_number}`}
                      className="bg-primary rounded text-white"
                      style={{ padding: "8px 8px" }}
                    >
                      <i className="fas fa-phone-alt"></i>
                    </a>
                  </div>
                )}
                {/* Contact Email */}
                {drive.hr_email && (
                  <div className="mb-3">
                    <h5 className="mb-2 fs-14 custom-label">Contact Email:</h5>
                    <div className="d-flex flex-wrap align-items-center">
                      <div
                        className="text-break me-2"
                        style={{ maxWidth: "80%" }}
                      >
                        {drive.hr_email}
                      </div>
                      <div>
                        <div
                          className="copy-division fs-18 text-dark cursor-pointer"
                          onClick={() => handleCopy(drive.hr_email, "email")}
                        >
                          <i className="fas fa-copy fs-18 icon-copy"></i>
                          {copyMessageEmail && (
                            <span
                              style={{ zIndex: 10 }}
                              className="copy-message fade-in-out"
                            >
                              Email copied!
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="card-footer p-0 border-0">
                <div className="d-flex align-items-start justify-content-between flex-wrap">
                  {drive.hr_email && (
                    <a
                      href={`mailto:${drive.hr_email}`}
                      className="btn btn-primary btn-sm mt-2"
                    >
                      <i className="fas fa-envelope me-2"></i> Send Email
                    </a>
                  )}
                  {drive.apply_online_url && (
                    <a
                      href={drive.apply_online_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-warning mt-2"
                    >
                      <i className="fa fa-check me-2"></i>Apply Now
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main content with job details */}
        <div className="col-lg-8 col-md-12">
          <div className="card">
            <div className="card-header d-block">
              <div>
                <h4
                  style={{ fontSize: 22 }}
                  className="d-flex gap-2 align-items-center justify-content-between mb-3"
                >
                  {drive.job_role_name ||
                    drive.other_job_role_name ||
                    "Campus Drive Job"}
                  <div>
                    {(() => {
                      switch (drive?.drive_status) {
                        case "live":
                          return (
                            <span
                              className="badge rounded-pill fs-12"
                              style={{
                                backgroundColor: "#e8f3ff",
                                color: "#005dba",
                                border: "1px solid #005dba",
                                padding: "8px 15px",
                                fontWeight: "500",
                              }}
                            >
                              <i className="fas fa-check-circle me-1"></i>
                              Live
                            </span>
                          );
                        case "hold":
                          return (
                            <span
                              className="badge rounded-pill fs-12"
                              style={{
                                backgroundColor: "#fff8e8",
                                color: "#ffc107",
                                border: "1px solid #ffc107",
                                padding: "8px 15px",
                                fontWeight: "500",
                              }}
                            >
                              <i className="fas fa-pause-circle me-1"></i>
                              Hold
                            </span>
                          );
                        case "cancelled":
                          return (
                            <span
                              className="badge rounded-pill fs-12"
                              style={{
                                backgroundColor: "#ffe8e8",
                                color: "#dc3545",
                                border: "1px solid #dc3545",
                                padding: "8px 15px",
                                fontWeight: "500",
                              }}
                            >
                              <i className="fas fa-times-circle me-1"></i>
                              Cancelled
                            </span>
                          );
                        case "draft":
                          return (
                            <span
                              className="badge rounded-pill fs-12"
                              style={{
                                backgroundColor: "#f1f1f1",
                                color: "#6c757d",
                                border: "1px solid #6c757d",
                                padding: "8px 15px",
                                fontWeight: "500",
                              }}
                            >
                              <i className="fas fa-pencil-alt me-1"></i>
                              Draft
                            </span>
                          );
                        case "closed":
                          return (
                            <span
                              className="badge rounded-pill fs-12"
                              style={{
                                backgroundColor: "#e8e8e8",
                                color: "#343a40",
                                border: "1px solid #343a40",
                                padding: "8px 15px",
                                fontWeight: "500",
                              }}
                            >
                              <i className="fas fa-lock me-1"></i>
                              Closed
                            </span>
                          );
                        default:
                          return (
                            <span
                              className="badge rounded-pill fs-12"
                              style={{
                                backgroundColor: "#f8f9fa",
                                color: "#6c757d",
                                border: "1px solid #6c757d",
                                padding: "8px 15px",
                                fontWeight: "500",
                              }}
                            >
                              <i className="fas fa-question-circle me-1"></i>
                              N/A
                            </span>
                          );
                      }
                    })()}
                  </div>
                </h4>
                <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                  <span className="mb-2 me-2">
                    <div className="fs-14">
                      <i className="fas fa-briefcase me-2 text-warning"></i>
                      {drive.company_name}
                    </div>
                  </span>
                  <span className="mb-2 me-2">
                    <div className="fs-14">
                      <i className="fas fa-map-marker-alt me-2 text-warning"></i>
                      {drive.company_address || "Pan India"}
                    </div>
                  </span>
                  {drive.course_name && (
                    <span className="mb-2 me-2">
                      <div className="fs-14">
                        <i className="fas fa-book me-2 text-warning"></i>
                        {drive.course_name}
                      </div>
                    </span>
                  )}
                  {drive.specialization_name && (
                    <span className="mb-2 me-2">
                      <div className="fs-14">
                        <i className="fas fa-user-graduate me-2 text-warning"></i>
                        {drive.specialization_name}
                      </div>
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Job Details */}
            <div className="card-body">
              <div className="row mb-3">
                {drive.remark && (
                  <Alert variant="secondary" className="mb-3">
                    {drive.remark}
                  </Alert>
                )}
                <div className="col-12">
                  <h4 className="fs-20 mb-3">Job Description</h4>
                  <div className="row">
                    <div
                      className="col-12 text-break"
                      dangerouslySetInnerHTML={{
                        __html: (
                          drive.job_description || "No description provided."
                        )
                          .replace(/\r\n/g, "<br />")
                          .replace(/\n/g, "<br />")
                          .replace(/\r/g, "<br />"),
                      }}
                    ></div>
                  </div>
                </div>
                {drive?.pre_placement_offer === "Yes" && (
                  <div className="col-12 mt-4">
                    <h4 className="fs-20 mb-3">PPO Eligibility Criteria</h4>
                    <div
                      className="text-break"
                      dangerouslySetInnerHTML={{
                        __html: (drive.ppo_eligibility_criteria || "N/A")
                          .replace(/\r\n/g, "<br />")
                          .replace(/\n/g, "<br />")
                          .replace(/\r/g, "<br />"),
                      }}
                    ></div>
                  </div>
                )}
                {drive.placement_eligibility_criteria && (
                  <div className="col-12 mt-4">
                    <h4 className="fs-20 mb-3">Eligibility Criteria</h4>
                    <div
                      className="text-break"
                      dangerouslySetInnerHTML={{
                        __html: (drive.placement_eligibility_criteria || "N/A")
                          .replace(/\r\n/g, "<br />")
                          .replace(/\n/g, "<br />")
                          .replace(/\r/g, "<br />"),
                      }}
                    ></div>
                  </div>
                )}
                {drive.placement_interview_rounds && (
                  <div className="col-12 mt-4">
                    <h4 className="fs-20 mb-3">Interview Rounds</h4>
                    <div
                      className="text-break"
                      dangerouslySetInnerHTML={{
                        __html: (drive.placement_interview_rounds || "N/A")
                          .replace(/\r\n/g, "<br />")
                          .replace(/\n/g, "<br />")
                          .replace(/\r/g, "<br />"),
                      }}
                    ></div>
                  </div>
                )}
                {drive.placement_terms_and_conditions && (
                  <div className="col-12 mt-4">
                    <h4 className="fs-20 mb-3">Terms & Conditions</h4>
                    <div
                      className="text-break"
                      dangerouslySetInnerHTML={{
                        __html: (drive.placement_terms_and_conditions || "N/A")
                          .replace(/\r\n/g, "<br />")
                          .replace(/\n/g, "<br />")
                          .replace(/\r/g, "<br />"),
                      }}
                    ></div>
                  </div>
                )}
                {/* Additional Documents */}
                {(drive.job_description_file_url ||
                  drive.additional_document_file_url) && (
                  <div className="col-12 mt-4">
                    <h4 className="fs-20 mb-3">Documents</h4>
                    <div className="d-flex flex-wrap gap-3">
                      {drive.job_description_file_url && (
                        <a
                          download
                          href={drive.job_description_file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="document-file-link d-flex align-items-center px-3 py-2 border rounded shadow-sm text-decoration-none mb-2"
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            background: "#f8f9fa",
                            transition: "box-shadow 0.2s",
                          }}
                        >
                          <i className="bi bi-file-earmark-text fs-3 me-2 text-primary"></i>
                          <span className="fw-semibold text-truncate">
                            Job Description File
                          </span>
                        </a>
                      )}
                      {drive.additional_document_file_url && (
                        <a
                          download
                          href={drive.additional_document_file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="document-file-link d-flex align-items-center px-3 py-2 border rounded shadow-sm text-decoration-none mb-2"
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            background: "#f8f9fa",
                            transition: "box-shadow 0.2s",
                          }}
                        >
                          <i className="bi bi-file-earmark-arrow-down fs-3 me-2 text-success"></i>
                          <span className="fw-semibold text-truncate">
                            Additional Document
                          </span>
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          .popover-custom {
            border: none;
            border-radius: 10px;
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
            background-color: #fff;
          }
          .icon-copy {
            color: #007bff;
          }
          .copy-div:hover {
            text-decoration: none;
            opacity: 0.8;
          }
          .copy-division {
            position: relative;
          }
          .copy-division2 {
            position: relative;
          }
          .copy-message {
            position: absolute;
            top: -30px;
            left: 10px;
            background-color: black;
            color: white;
            padding: 5px 8px;
            border-radius: 5px;
            font-size: 14px;
            white-space: nowrap;
            opacity: 0;
            transition: opacity 0.5s ease;
          }
          .copy-message.fade-in-out {
            opacity: 1;
          }
          @media (max-width: 767px) {
            .card-header,
            .card-body {
              padding: 15px;
            }
            .copy-message {
              left: -15px;
            }
          }
        `}</style>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Notification
          </Modal.Title>
          <Button
            onClick={() => setModalShow(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body className="p-4">
          {/* Radio Buttons for Email/Push */}
          {/* <Form.Group>
            <Form.Label>Type</Form.Label>
            <div className="d-flex align-items-center" style={{ gap: 10 }}>
              <Form.Check
                type="radio"
                label="Email"
                name="notificationType"
                id="email"
                checked={formType === "Email"}
                onChange={() => setFormType("Email")}
              />
              <Form.Check
                type="radio"
                label="Push"
                name="notificationType"
                id="push"
                checked={formType === "Push"}
                onChange={() => setFormType("Push")}
              />
            </div>
          </Form.Group> */}

          {/* Dropdown to Select Course */}
          <Form.Group className="mt-3">
            <Form.Label>Select Course</Form.Label>
            <Form.Control
              as="select"
              onChange={(e) => {
                if (e.target.value == "Select Course") {
                  setMasterCourseId(null);
                  setspecializationId(0);
                  setCourseId(null);
                  setSpecialization([]);
                  setMasterCourseId(null);
                } else {
                  setMasterCourseId(e.target.value);
                }
              }}
              id="courseSelect"
            >
              <option value={"Select Course"}>Select Course</option>
              {courses?.map((courses) => (
                <option value={courses.course_master_id}>{courses.name}</option>
              ))}
            </Form.Control>
          </Form.Group>

          {/* Select All/Branch Option */}
          <Form.Group className="mt-3">
            <Form.Label>Select Branch</Form.Label>
            <Form.Control
              onChange={(e) => {
                if (e.target.value == "Select All") {
                  setspecializationId(0);
                } else {
                  setspecializationId(e.target.value);
                }
              }}
              as="select"
              id="branchSelect"
            >
              <option selected value="Select All">
                Select All
              </option>
              {specialization?.map((specialize) => (
                <option value={specialize.specilization_master_id}>
                  {specialize.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          {/* Dropdown to Select Passout Year */}
          <Form.Group className="mt-3">
            <Form.Label>Select Passout Year</Form.Label>
            <Form.Control
              onChange={(e) => setPassoutYear(e.target.value)}
              as="select"
              id="passoutYearSelect"
            >
              <option>Select Year</option>
              <option value={currentYear}>{currentYear}</option>
              <option value={currentYear + 1}>{currentYear + 1}</option>
              <option value={currentYear + 2}>{currentYear + 2}</option>
            </Form.Control>
          </Form.Group>

          {/* Textarea for message */}
          <Form.Group className="mt-3">
            {formType === "Push" && (
              <>
                <Form.Label>Push Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  onChange={(e) => setMessage(e.target.value)}
                  className=""
                  id="exampleFormControlTextarea1"
                  placeholder="Write here..."
                  style={{ height: "100px", border: "1px solid #cccccc" }}
                />
              </>
            )}
            {formType === "Email" && (
              <>
                <div className="col-xl-12">
                  <div className="mb-3">
                    <label className="form-label">Email Template</label>
                    <div
                      className="custom-ekeditor mb-3"
                      style={{ height: 150 }}
                    >
                      <CkEditorBlog
                        data={message}
                        onChange={handleEditorChange}
                      />
                    </div>
                    <div className="form-text mb-3">
                      This design will show in recieved email and place holders
                      will replace with dynamic content.
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)} variant="danger light">
            Close
          </Button>
          <Button
            onClick={() =>
              sendNotification({
                masterCourseId,
                specializationId,
                passoutyear,
                message,
                formType,
                job: driveId,
              })
            }
            variant="primary"
            disabled={isSendingNotification}
          >
            {isSendingNotification ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Sending...
              </>
            ) : (
              "Send"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CampusDriveDetails;
